/** Load a cross-origin-safe image (watermark/overlay) for compositing into the capture canvas. */
export function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous"; // keep the capture canvas un-tainted so toBlob works
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`failed to load image: ${url}`));
    image.src = url;
  });
}

/**
 * Load an optional watermark. The watermark is decorative branding, not the user's photo — a
 * missing/broken asset must NOT fail the whole capture, so this resolves to undefined (and warns)
 * instead of rejecting.
 */
export async function loadOptionalWatermark(
  url: string | undefined,
  load: (url: string) => Promise<HTMLImageElement> = loadImage,
): Promise<HTMLImageElement | undefined> {
  if (!url) return undefined;
  try {
    return await load(url);
  } catch (error) {
    console.warn(`watermark unavailable, capturing without it: ${url}`, error);
    return undefined;
  }
}
